import { render, staticRenderFns } from "./AlbaranSingle.vue?vue&type=template&id=609a2b66&scoped=true&lang=pug"
import script from "./AlbaranSingle.vue?vue&type=script&lang=js"
export * from "./AlbaranSingle.vue?vue&type=script&lang=js"
import style0 from "./AlbaranSingle.vue?vue&type=style&index=0&id=609a2b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a2b66",
  null
  
)

export default component.exports